import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { usePagination } from 'react-use-pagination'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faPhone, faLocationDot } from '@fortawesome/free-solid-svg-icons'
import { Pagination } from '/src/components/common'
import { useEnquiries } from '/src/hooks'

import './enquiry_list.scss'

export const EnquiryListItem = ({ 
  title, 
  field_mc_product_enquiry_body, 
  field_mc_product_enquiry_email, 
  field_mc_product_enquiry_phone,
  field_mc_product_enquiry_postal,
  field_mc_product_enquiry_suburb
}) => {
  return (
    <div className="enquiry-list-item mb-3">
      <ul>
        <li><FontAwesomeIcon icon={faEnvelope} /> {field_mc_product_enquiry_email}</li>
        <li><FontAwesomeIcon icon={faPhone} /> {field_mc_product_enquiry_phone}</li>
        <li><FontAwesomeIcon icon={faLocationDot} /> {field_mc_product_enquiry_postal}</li>
      </ul>
      <div className="content mt-2">
        <p>{field_mc_product_enquiry_body}</p>
      </div>
    </div>
  )
}

const EnquiryListEmpty = () => {
  return <>No results found.</>
}

const EnquiryListResults = ({ values }) => {
  return values.map((enquiry, index) => {
    return (
      <Col key={index} xs={12}>
        <EnquiryListItem {...enquiry} />
      </Col>
    )
  })
}

export const EnquiryList = ({ pagination = true, limit = 6 }) => {
  const enquiries = useEnquiries()
  const {
    pageSize,
    currentPage,
    setPage,
    startIndex,
    endIndex,
  } = usePagination({ 
    totalItems: enquiries.length,
    initialPageSize: limit
  })
  const values = enquiries.slice(startIndex, endIndex + 1)

  return (
    <div className="enquiry-list-container">
      <Row>
        {values.length ? <EnquiryListResults values={values} /> : <EnquiryListEmpty />}
      </Row>
      {pagination && (
        <Row>
          <Col sm={12} className="d-flex align-items-center justify-content-center">
            <Pagination
              currentPage={currentPage}
              totalItems={enquiries}
              pageSize={pageSize}
              setPage={setPage}
            />
          </Col>
        </Row>
      )}
    </div>
  )
}
